export default __webpack_public_path__ + "static/media/deanphoto.9cec7acf.png";